import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import { getConfig } from '../../../config';
import { Clickable } from '@fabric-ds/react';
import { useMemo } from 'react';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    disableTextBalancer?: boolean;
    hideSponsor?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    hideSponsor = false,
}: // smallText = false,
ContentMarketingTextContainerType) => {
    const { deviceType } = getConfig();
    const isMobile = deviceType === 'mobile';
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');
    const cleanTitle = contentMarketing?.title.replace(/\\n/g, '');

    // const ref = useRef<HTMLParagraphElement>();
    // useTextBalancer(ref, disableTextBalancer || isMobile);

    const stikkTitle = useMemo(() => {
        return isMobile
            ? contentMarketing?.text
            : contentMarketing?.textDesktop
            ? contentMarketing?.textDesktop
            : contentMarketing?.text;
    }, [isMobile, contentMarketing.text, contentMarketing.textDesktop]);

    const accessibilityId = `cm-title-${contentMarketing.id}`;
    return (
        <div>
            {!hideSponsor && Boolean(contentMarketing.sponsorData.name) && (
                <div className={`text-gray-500 text-14 mb-4`}>
                    <span>{contentMarketing.sponsorData.name}</span>
                </div>
            )}
            {!!stikkTitle && (
                <div className={`mb-0 text-left text-14 sm:text-16 font-bold`}>
                    {stikkTitle}
                </div>
            )}
            <h2
                className={`h3 sm:h2 font-normal text-left mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                id={accessibilityId}
            >
                <Clickable
                    href={contentMarketing.href}
                    rel="noreferrer"
                    target="_blank"
                    title={cleanTitle}
                    id={accessibilityId}
                    className={
                        'link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring'
                    }
                >
                    <div
                        className={`w-full text-left`}
                        data-testid={'cm-title'}
                    >
                        {title}
                    </div>
                </Clickable>
            </h2>
        </div>
    );
};

export default TextContainer;
